module.exports = "/images/mara.png?0be59146c5d4b48dbb62f45d9a5e7c25";